<template>
    <div>
        <b-form-invalid-feedback :state="hasErrors(name, errors)" v-if="errors[name]">
            {{ errors[name][0] }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
export default {
    props: ['name', 'errors']
}
</script>

<style scoped>

</style>
